export { SlidersProvider, useSlidersStore, type SlidersStoreValue } from "@/stores/slider/SlidersProvider";

